import { env } from "@/lib/env";
import axios from "axios";
import { toast } from "sonner";
import { HttpFeedback } from "./feedback";
import { refreshActivity } from "./refresh-activity";
import { SessionCoordinator } from "./session";
import { createHttpTransport } from "./transport";
import type { HttpClientDependencies } from "./types";

export function composeHttpTransport(dependencies: HttpClientDependencies) {
  const storage = dependencies.storage ?? localStorage;
  const notifications = dependencies.notifications ?? toast;
  const redirect =
    dependencies.redirect ??
    ((path: string) => {
      window.location.href = path;
    });
  const currentPath =
    dependencies.currentPath ??
    (() => window.location.pathname + window.location.search + window.location.hash);
  const refreshTransport = axios.create({
    baseURL: env.apiUrl,
    timeout: 60000,
    adapter: dependencies.adapter,
    headers: { "Content-Type": "application/json" },
  });
  const session = new SessionCoordinator(storage, refreshTransport, refreshActivity);
  const feedback = new HttpFeedback(storage, notifications, redirect, currentPath);
  return createHttpTransport({
    baseURL: env.apiUrl,
    adapter: dependencies.adapter,
    session,
    feedback,
  });
}
